import BasicLayout from '../../layouts/BasicLayout'
import SubTitle from '../../components/user/SubTitle'
import ServiceContent from '../../components/user/ServiceContent'
import MetaTag from '../../components/user/MetaTag'

function ServicesPage() {
    return (
        <BasicLayout>
            <div className="max-w-6xl mx-auto px-4 py-8">
                <MetaTag
                    title="브랜드 스토리 | 더룸이 추구하는 인테리어 가치"
                    description="더룸(THEROOM)은 단순한 인테리어가 아닌, 생활 방식에 맞춘 공간을 지향합니다. 우리는 어떤 기준으로 집을 바라보고, 어떤 가치로 리모델링을 제안하는지 브랜드 철학을 소개합니다."
                    imgsrc="https://www.theroom.co.kr/assets/logos/og-image.png"
                    url="https://www.theroom.co.kr/brand"
                />
                <SubTitle content={"BRAND"} />
                <ServiceContent />
            </div>
        </BasicLayout>
    )
}

export default ServicesPage